mutation verifyHoppermationDomain($companyId: ID!) {
  domain: verifyHoppermationDomain(companyId: $companyId) {
    domain
    dkimHost
    dkimText
    returnPathDomain
    returnPathDomainCname
    isDKIMVerified
    isReturnPathDomainVerified
  }
}
